/* eslint-disable camelcase */
import parseResolutions from 'helpers/parseResolutions'
import calculateAspectRatio from 'helpers/calculations/calculateAspectRatio'
import calculateVerticalAngleOfView from 'helpers/calculations/calculateVerticalAngleOfView'
import convertHorizontalAngleOfViewToVertical from 'helpers/convertHorizontalAngleOfViewToVertical'
import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import calculateVerticalFieldOfView from 'helpers/calculations/calculateVerticalFieldOfView'
import calculateFocalLength from 'helpers/calculations/calculateFocalLength'
import modelAovType from 'helpers/modelAovType'
import getImagerSize from 'helpers/cameras/getImagerSize'
import modelFocalLengthSelector from 'helpers/cameras/modelFocalLengthSelector'
import calculateDistanceFromHorizontalFieldOfView from 'helpers/calculations/calculateDistanceFromHorizontalFieldOfView'
import { CONVENTIONAL } from 'helpers/globals'

function chooseAovFromModel(model, cameraAngleOfView) {
  switch (modelAovType(model)) {
    case 'variable':
      return cameraAngleOfView
    case 'fixed':
      return parseFloat(model.aov.min)
    case 'range':
      if (cameraAngleOfView <= parseFloat(model.aov.max) && cameraAngleOfView >= parseFloat(model.aov.min)) {
        return cameraAngleOfView
      } else {
        return (parseFloat(model.aov.max) - parseFloat(model.aov.min)) / 2
      }
  }
}

export default function updateModel(camera, { model, aov, skipClearPpfNightMode }) {
  // if no model or aov is passed, remove the camera model
  if (!model && !aov) {
    let newCam = Object.assign({}, camera)
    delete newCam.model
    return newCam
  }

  const { id, imager_count, imager_size, infrared, text, resolution, resolution_name, form_factor, super_low_light,
    imager_option_ids, ptz_imager_option_ids, multi_imager_type, is_fisheye, manufacturer } = model
  const aovDetails =
  aov
  ? Object.assign(
    {},
    aov && {
      id: aov.id,
      min: parseFloat(aov.min),
      minVertical: parseFloat(convertHorizontalAngleOfViewToVertical({
        horizontalAngleOfView: aov.min,
        resolution
      }).toFixed(2)),
      range: aov.range_text
    },
    aov.max && {
      maxVertical: parseFloat(convertHorizontalAngleOfViewToVertical({
        horizontalAngleOfView: aov.max,
        resolution
      }).toFixed(2)),
      max: parseFloat(aov.max)
    }
  )
  : null

  const modelDetails = Object.assign({}, { aov: aovDetails },
    {
      formFactor: form_factor,
      imagerCount: imager_count,
      imagerSize: imager_size,
      name: text,
      manufacturer: manufacturer,
      model: model.model,
      focalLength: modelFocalLengthSelector(model, aov),
      superLowLight: super_low_light || false,
      resolution,
      resolution_name,
      id,
      infrared,
      imager_option_ids,
      ptz_imager_option_ids,
      multi_imager_type,
      is_fisheye
    },
    is_fisheye && { other_fisheye_aov: aov ? model.aovs.find(a => aovDetails.id !== a.id) : model.aovs.find(a => parseFloat(a.min) !== camera.horizontalAngleOfView) }
  )

  const horizontalResolution = parseResolutions(resolution).horizontal
  const verticalResolution = parseResolutions(resolution).vertical
  const horizontalAngleOfView = aov ? chooseAovFromModel({ ...model, aov }, camera.horizontalAngleOfView) : camera.horizontalAngleOfView
  const horizontalFieldOfView = calculateHorizontalFieldOfView({ horizontalAngleOfView, distance: camera.distanceToTarget })
  const distance = calculateDistanceFromHorizontalFieldOfView({ horizontalFieldOfView, angleOfView: horizontalAngleOfView })
  const aspectRatio = calculateAspectRatio({ horizontalResolution, verticalResolution })
  const updatedCamera = Object.assign({}, camera, {
      imagerSize: getImagerSize(imager_size),
      imagerCount: imager_count,
      verticalAngleOfView: aov ? calculateVerticalAngleOfView({ horizontalAngleOfView, aspectRatio }) : camera.verticalAngleOfView,
      horizontalAngleOfView,
      horizontalResolution,
      verticalResolution,
      aspectRatio,
      ppf: calculatePpf({ horizontalResolution, horizontalFieldOfView, model: modelDetails, distance }),
      horizontalFieldOfView,
      verticalFieldOfView: calculateVerticalFieldOfView({ aspectRatio, horizontalFieldOfView }),
      focalLength: calculateFocalLength({ horizontalAngleOfView, imagerSize: getImagerSize(imager_size) })
    },
    !skipClearPpfNightMode && { userSelectedPpfNightMode: false },
    horizontalAngleOfView >= 180 && { fovMode: CONVENTIONAL },
    is_fisheye && { userSelectedGeneralScene: false, fovMode: CONVENTIONAL, tilt: 0 }
  )

  return Object.assign({}, updatedCamera, { model: modelDetails })
}



// WEBPACK FOOTER //
// ./src/reducers/updateModel.js